<template>
    <b-container class="bg-light mt-4 pb-2 pt-2">
        <router-view></router-view>
    </b-container>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        
    },
    beforeCreate() {
        
    },
    created() {
        
    },
    beforeMount() {
        
    },
    mounted() {
        
    },
    beforeUpdate() {
        
    },
    updated() {

    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/institutes.vue